import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { FilterQuery, PaginatedResponse, User } from "../models/model";
import { extractPaginatedResponse } from "./pagination.utils";
import { SignalRService } from "./signalr-service";

@Injectable({ providedIn: 'root' })
export class UserService extends SignalRService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = environment.apiUrl + '/user';

    list(filterQuery: FilterQuery): Observable<PaginatedResponse<User>> {
        return this.http.post<User[]>(`${this.apiUrl}/list`, filterQuery, { observe: 'response' })
            .pipe(map(extractPaginatedResponse));
    }

    me(): Observable<User> {
        return this.http.get<User>(`${this.apiUrl}/me`);
    }

    delete(userId: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${userId}`);
    }

    override startConnection(): Promise<void> {
        return super.startConnection('/user');
    }
}